module.exports = __webpack_public_path__ + "static/media/undraw_team_work_k-80-m.caa53e10.svg";